// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ForgotPassword_loginContainer__vLXV0 {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f4f6f9;
  padding: 1rem;
}

.ForgotPassword_loginCard__GUZpF {
  background-color: #fff;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  width: 100%;
  max-width: 400px;
}

.ForgotPassword_loginTitle__MLNYB {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  color: #333;
  text-align: center;
  padding: 1rem;
}

.ForgotPassword_loginSubtitle__zM7Qh {
  font-size: 0.95rem;
  color: #666;
  margin-bottom: 1.5rem;
  line-height: 1.1 !important;
  text-align: center;
  padding: 1em;
}

.ForgotPassword_loginForm__Rm8ji {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.ForgotPassword_errorMessage__7kB2R {
  color: #6c757d;
  margin-bottom: 2rem;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.ForgotPassword_loadingText__Z26ny {
  margin-top: 1rem;
  color: #6c757d;
}

.ForgotPassword_submittingOverlay__0OauI {
  text-align: center;
  margin-top: 1rem;
  color: #007bff;
}
.ForgotPassword_submittingOverlay__0OauI p {
  margin-top: 0.5rem;
}

.ForgotPassword_linkText__UQJpC {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
  font-size: 0.9rem;
  color: #555;
  transition: color 0.2s ease;
}
.ForgotPassword_linkText__UQJpC:hover {
  color: #000;
  text-decoration-line: underline;
}

.ForgotPassword_back__s\\+Sn- {
  text-align: center;
  cursor: pointer;
  color: #666;
}
.ForgotPassword_back__s\\+Sn-:hover {
  color: var(--orange);
  text-decoration-line: underline;
}`, "",{"version":3,"sources":["webpack://./src/pages/ForgotPassword/ForgotPassword.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,aAAA;AACJ;;AAGA;EACI,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,0CAAA;EACA,WAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,2BAAA;EACA,kBAAA;EACA,YAAA;AAAJ;;AAGA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AAAJ;;AAGA;EACI,cAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,cAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,gBAAA;EACA,cAAA;AAAJ;AAEI;EACI,kBAAA;AAAR;;AAIA;EACI,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,2BAAA;AADJ;AAGI;EACI,WAAA;EACA,+BAAA;AADR;;AAMA;EACI,kBAAA;EACA,eAAA;EACA,WAAA;AAHJ;AAII;EACI,oBAAA;EACA,+BAAA;AAFR","sourcesContent":[".loginContainer {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    min-height: 100vh;\r\n    background-color: #f4f6f9;\r\n    padding: 1rem;\r\n\r\n}\r\n\r\n.loginCard {\r\n    background-color: #fff;\r\n    padding: 2rem;\r\n    border-radius: 8px;\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\r\n    width: 100%;\r\n    max-width: 400px;\r\n}\r\n\r\n.loginTitle {\r\n    font-size: 1.5rem;\r\n    font-weight: 600;\r\n    margin-bottom: 1.5rem;\r\n    color: #333;\r\n    text-align: center;\r\n    padding: 1rem;\r\n}\r\n\r\n.loginSubtitle {\r\n    font-size: 0.95rem;\r\n    color: #666;\r\n    margin-bottom: 1.5rem;\r\n    line-height: 1.1 !important;\r\n    text-align: center;\r\n    padding: 1em;\r\n}\r\n\r\n.loginForm {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 1rem;\r\n}\r\n\r\n.errorMessage {\r\n    color: #6c757d;\r\n    margin-bottom: 2rem;\r\n    padding: 1rem;\r\n    background-color: #f8f9fa;\r\n    border-radius: 8px;\r\n    border: 1px solid #e9ecef;\r\n}\r\n\r\n.loadingText {\r\n    margin-top: 1rem;\r\n    color: #6c757d;\r\n}\r\n\r\n.submittingOverlay {\r\n    text-align: center;\r\n    margin-top: 1rem;\r\n    color: #007bff;\r\n\r\n    p {\r\n        margin-top: 0.5rem;\r\n    }\r\n}\r\n\r\n.linkText {\r\n    display: flex;\r\n    justify-content: center;\r\n    margin-top: 1rem;\r\n    font-size: 0.9rem;\r\n    color: #555;\r\n    transition: color 0.2s ease;\r\n\r\n    &:hover {\r\n        color: #000;\r\n        text-decoration-line: underline;\r\n    }\r\n}\r\n\r\n\r\n.back {\r\n    text-align: center;\r\n    cursor: pointer;\r\n    color: #666;\r\n    &:hover {\r\n        color: var(--orange);\r\n        text-decoration-line: underline;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loginContainer": `ForgotPassword_loginContainer__vLXV0`,
	"loginCard": `ForgotPassword_loginCard__GUZpF`,
	"loginTitle": `ForgotPassword_loginTitle__MLNYB`,
	"loginSubtitle": `ForgotPassword_loginSubtitle__zM7Qh`,
	"loginForm": `ForgotPassword_loginForm__Rm8ji`,
	"errorMessage": `ForgotPassword_errorMessage__7kB2R`,
	"loadingText": `ForgotPassword_loadingText__Z26ny`,
	"submittingOverlay": `ForgotPassword_submittingOverlay__0OauI`,
	"linkText": `ForgotPassword_linkText__UQJpC`,
	"back": `ForgotPassword_back__s+Sn-`
};
export default ___CSS_LOADER_EXPORT___;
